export enum ORGANIC_STATES {
  conventional = 'conventional',
  organic = 'organic',
  conversion = 'conversion',
}

export enum COLORS {
  grey = '#d2d2d2',
  green = '#277134',
  yellow = '#e69636',
  white = '#FFFFFF',
  black = '#000000',
}
